import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const Search = () => {
    const [searchParams] = useSearchParams();
    const query = searchParams.get("query");
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (query) {
            fetchSearchResults(query);
        }
    }, [query]);

    const fetchSearchResults = async (query) => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(`http://127.0.0.1:8000/api/search?query=${encodeURIComponent(query)}`);
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();
            setResults(data);
        } catch (error) {
            console.error("Error fetching search results:", error);
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className="main">
            <div className="container-fluid">
                <section className="row row--grid">
                    <div className="col-12">
                        <div className="main__title">
                            <h2>Search Results for "{query}"</h2>
                        </div>
                    </div>

                    {loading ? (
                        <div className="col-12">
                            <p>Loading...</p>
                        </div>
                    ) : error ? (
                        <div className="col-12">
                            <p>Error: {error}</p>
                        </div>
                    ) : results.length === 0 ? (
                        <div className="col-12">
                            <p>No results found.</p>
                        </div>
                    ) : (
                        results.map((channel) => (
                            <div className="col-6 col-sm-4 col-lg-2" key={channel.id}>
                                <div className="album">
                                    <div className="album__cover">
                                        <img src={channel.favicon} alt={`${channel.name} logo`} />
                                        <a href={channel.url_resolved} target="_blank" rel="noopener noreferrer">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                <path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Z" />
                                            </svg>
                                        </a>
                                    </div>
                                    <div className="album__title">
                                        <h3>{channel.name}</h3>
                                        <span>{channel.language} - {channel.country}</span>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </section>
            </div>
        </main>
    );
};

export default Search;